import React, { useMemo, useState } from "react"
import { Button, Modal } from "react-bootstrap"
import SweetAlert from "react-bootstrap-sweetalert"
import * as xlsx from 'xlsx'
import PbUmkuService from "../../../../services/pbumku/PbumkuService"

const ModalLaporan = ({ showAddLaporan, handleCloseAddLaporan, rowData, reloadList }) => {
    // console.log(rowData)

    const [showConfirmLaporan, setShowConfirmLaporan] = useState(false)
    const handleCloseConfirmLaporan = () => setShowConfirmLaporan(false)
    const [showFileEmpty, setShowFileEmpty] = useState(false)
    const handleCloseShowFileEmpty = () => setShowFileEmpty(false)
    const [showLaporanSuccess, setShowLaporanSuccess] = useState(false)
    const [showLaporanFailed, setShowLaporanFailed] = useState(false)
    const [fileName, setFileName] = useState('')
    const [fileContent, setFileContent] = useState('')

    const [totalSesuai, setTotalSesuai] = useState('')
    const [totalMinor, setTotalMinor] = useState('')
    const [totalMayor, setTotalMayor] = useState('')
    const [totalKritis, setTotalKritis] = useState('')
    const [totalHasil, setTotalHasil] = useState('')
    const [keterangan, setKeterangan] = useState('')

    let pbumkuService = useMemo(() => new PbUmkuService(), [])

    const handleUploadFile = (e) => {
        e.preventDefault()
        if (e.target.files) {
            setFileName(e.target.files[0].name)
            const reader = new FileReader()
            reader.onload = (e) => {
                const data = e.target.result
                const workbook = xlsx.read(data, { type: "array" })
                const sheetname = workbook.SheetNames[0]
                const worksheet = workbook.Sheets[sheetname]
                const json = xlsx.utils.sheet_to_json(worksheet, { range: 2 })
                // console.log(JSON.stringify(json, null))
                // console.log(json)

                if (rowData.urIzinSingkat === 'CPIB') {
                    json.map((djson, idx) => {
                        // console.log(djson)
                        if(djson.Persyaratan === 'Jumlah Checklist'){
                            setTotalSesuai(djson.Ketidaksesuaian)
                            setTotalMinor(djson.__EMPTY)
                            setTotalMayor(djson.__EMPTY_1)
                            setTotalKritis(djson.__EMPTY_2)
                        } else if(djson.Persyaratan === 'Nilai Kelulusan'){
                            setKeterangan((Math.round(djson.__EMPTY_3 * 100) / 100) + ' - ' +djson.Ket)
                            setTotalHasil(djson.Ket)
                        } else if(djson.Persyaratan === 'Jumlah Kritis'){
                            // setTotalHasil(djson.Ket)
                        }
                        return djson
                    })
                } else {
                    let lastJson = json[json.length - 1]
                    // console.log(lastJson)
                    setTotalSesuai(lastJson.Ketidaksesuaian)
                    setTotalMinor(lastJson.__EMPTY)
                    setTotalMayor(lastJson.__EMPTY_1)
                    setTotalKritis(lastJson.__EMPTY_2)
                    setTotalHasil(lastJson.__EMPTY_3)
                }
            }
            reader.readAsArrayBuffer(e.target.files[0])

            const reader2 = new FileReader()
            reader2.onload = (e) => {
                const base64Content = e.target.result.split(',')[1]
                setFileContent(base64Content)
            }
            reader2.readAsDataURL(e.target.files[0])
        }
    }

    const SaveLaporan = () => {
        if (fileContent !== '') {
            setShowConfirmLaporan(true)
        } else {
            setShowFileEmpty(true)
        }
    }

    const handleClickLaporan = async () => {
        try {
            let jsonLaporan = {
                idoss: rowData.idoss,
                idpryk: rowData.idpryk,
                idchecklist: rowData.idchecklist,
                idspt: rowData.idSpt,
                nib: rowData.nib,
                statusLap: '000',
                createdBy: localStorage.getItem('userId'),
                createdDate: new Date()
            }
            console.log(jsonLaporan)
            const _resLapHdr = await pbumkuService.saveLaporanHeader(jsonLaporan)
            if (_resLapHdr.data.kode === '200') {
                const _resHeader = await pbumkuService.findLaporanHeaderByIdossIdprykIdchecklistIdspt(rowData.idoss, rowData.idpryk, rowData.idchecklist, rowData.idSpt)
                // console.log(_resHeader)
                let jsonFile = {
                    idlaphdr: _resHeader.data.idlaphdr,
                    fileNama: fileName,
                    fileContent: fileContent,
                    statusFile: '000',
                    createdBy: localStorage.getItem('userId'),
                    createdDate: new Date(),
                    totalSesuai: totalSesuai,
                    totalMinor: totalMinor,
                    totalMayor: totalMayor,
                    totalKritis: totalKritis,
                    totalHasil: totalHasil,
                    keterangan: keterangan
                }
                // console.log(jsonFile)
                const _resLapFile = await pbumkuService.saveLaporanFile(jsonFile)
                if (_resLapFile.data.kode === '200') {
                    setShowLaporanSuccess(true)
                    setShowConfirmLaporan(false)
                } else {
                    setShowLaporanFailed(true)
                    setShowConfirmLaporan(false)
                }
            } else {
                setShowLaporanFailed(true)
                setShowConfirmLaporan(false)
            }
        } catch (error) {
            setShowLaporanFailed(true)
            console.log(error)
        }
    }

    const handleClickLaporanSuccess = () => {
        setShowLaporanSuccess(false)
        handleCloseAddLaporan()
        reloadList(0, 10)
    }

    const handleClickLaporanFailed = () => {
        setShowLaporanFailed(false)
    }

    const handleBatal = () => {
        handleCloseAddLaporan()
        setTotalHasil('')
        setTotalSesuai('')
        setTotalMinor('')
        setTotalMayor('')
        setTotalKritis('')
        setFileContent('')
        setFileName('')
        setKeterangan('')
    }

    return (
        <>
            <Modal show={showAddLaporan} onHide={handleCloseAddLaporan} backdrop='static' keyboard={false} scrollable={true} size="xl" centered>
                <Modal.Header><h6>Form Laporan Hasil (Checklist)</h6></Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Perizinan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.urIzin} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">NIB / Nama Perusahaan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && (rowData.nib + ' / ' + rowData.namaPerseroan)} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor / Tanggal Permohonan</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="idIzin" defaultValue={rowData !== null && rowData.idIzin + ' / ' + rowData.tglPermohonan} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor Kegiatan Usaha</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nomor_proyek" defaultValue={rowData !== null && rowData.nomorProyek} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Usaha</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.uraianUsaha} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Nomor / Tanggal SPT</label>
                        <div className="col-sm-8">
                            <input type="text" className="col-sm-12 form-control-sm" name="nib" defaultValue={rowData !== null && rowData.nomorSpt + ' / ' + rowData.tanggalSpt} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm">Upload Checklist (file extension .xlsx | max 2 Mb)</label>
                        <div className="col">
                            <input type="file" className="form-control-sm" name="upload_file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                placeholder="Upload File Excel Checklist"
                                onChange={e => handleUploadFile(e)} />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Total Ketidaksesuaian</strong></label>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-1 col-form-label-sm">Sesuai</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="sesuai" defaultValue={totalSesuai} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Minor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="minor" defaultValue={totalMinor} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Mayor</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="mayor" defaultValue={totalMayor} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Kritis</label>
                        <div className="col-sm-2">
                            <input type="text" className="col-sm-12 form-control-sm" name="kritis" defaultValue={totalKritis} disabled />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <label className="col-sm-4 col-form-label-sm"><strong>Hasil / Nilai Kuantitaif</strong></label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="hasil" defaultValue={totalHasil} disabled />
                        </div>
                        <label className="col-sm-1 col-form-label-sm">Keterangan</label>
                        <div className="col-sm-3">
                            <input type="text" className="col-sm-12 form-control-sm" name="keterangan" defaultValue={keterangan} disabled />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" size="sm" onClick={() => SaveLaporan()} >Simpan</Button>{' '}
                    <Button variant="danger" size="sm" onClick={() => handleBatal()}>
                        Batal
                    </Button>
                </Modal.Footer>
            </Modal>
            {
                showConfirmLaporan &&
                <SweetAlert
                    title="Simpan Laporan Checklist?"
                    warning
                    showCancel
                    confirmBtnText="Proses"
                    confirmBtnBsStyle="primary"
                    cancelBtnText="Batal"
                    cancelBtnBsStyle="secondary"
                    onConfirm={handleClickLaporan}
                    onCancel={handleCloseConfirmLaporan}
                    focusCancelBtn
                    reverseButtons={true}
                    btnSize="sm"
                />
            }
            {
                showLaporanSuccess &&
                <SweetAlert
                    title="Laporan Berhasil Disimpan"
                    success
                    onConfirm={handleClickLaporanSuccess}
                    btnSize="sm"
                />
            }
            {
                showLaporanFailed &&
                <SweetAlert
                    title="Laporan Gagal Disimpan"
                    danger
                    onConfirm={handleClickLaporanFailed}
                    btnSize="sm"
                    timeout={2000}
                />
            }
            {
                showFileEmpty &&
                <SweetAlert
                    title="FIle Harus Diupload"
                    danger
                    onConfirm={handleCloseShowFileEmpty}
                    btnSize="sm"
                />
            }
        </>
    )
}

export default ModalLaporan